import { CheckedState } from "@radix-ui/react-checkbox";
import { Checkbox } from "../ui/checkbox";

interface PropertyOptionsFormProps {
  formData: {
    available: boolean;
    featured: boolean;
  };
  handleInputChange: (field: string, value: CheckedState) => void;
  canEdit?: boolean;
}

const PropertyOptionsForm = ({
  formData,
  handleInputChange,
  canEdit = false,
}: PropertyOptionsFormProps) => (
  <div className="space-y-4">
    <div className="flex items-center space-x-2">
      <Checkbox
        id="available"
        checked={formData.available}
        onCheckedChange={(checked) => handleInputChange("available", checked)}
      />
      <label htmlFor="available" className="text-sm font-medium">
        Propiedad disponible
      </label>
    </div>

    <div className="flex items-center space-x-2">
      <Checkbox
        id="featured"
        checked={formData.featured}
        disabled={!canEdit}
        onCheckedChange={(checked) => handleInputChange("featured", checked)}
      />
      <label htmlFor="featured" className="text-sm font-medium">
        Propiedad destacada
      </label>
    </div>
  </div>
);

export default PropertyOptionsForm;
